import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin-top": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": true,
    title: "角色上级经理详情",
    width: "750px",
    "model-value": $props.visible,
    "show-close": true,
    onClose: $setup.close,
    center: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions, {
      title: "",
      border: "true"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
        label: "用户名称：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.userInfo.empName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "电话：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.userInfo.mobile), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "用户组织结构：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.userInfo.limitName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "原上级名称：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.originManagerName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "原上级组织结构：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.originManagerLimit), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "原上级工号：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.originManagerNum), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "现上级名称：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.managerName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "现上级组织结构：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.managerLimit), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "现上级工号：",
        "label-align": "center",
        align: "center"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.sysManager.managerNum), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "",
        "label-align": "center"
      }), _createVNode(_component_el_descriptions_item, {
        label: "",
        "label-align": "center"
      }), _createVNode(_component_el_descriptions_item, {
        label: "操作",
        "label-align": "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "danger",
          size: "small",
          onClick: $setup.deleteManager
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("删除当前上级 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_card, null, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        inline: true,
        model: _ctx.queryParam,
        ref: "userManagerForm"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "empName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.queryParam.empName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.queryParam.empName = $event),
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "手机",
          prop: "mobile"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.queryParam.mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.queryParam.mobile = $event),
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "组织结构",
          prop: "limitName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.queryParam.limitName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.queryParam.limitName = $event),
            size: "small"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = $event => $setup.submitForm('userManagerForm'))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("查询 ", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = $event => $setup.resetForm('userManagerForm'))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("重置", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_table, {
        data: _ctx.tableData,
        "header-cell-style": {
          background: '#FAFAFA'
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            "show-overflow-tooltip": item.overflow ? item.overflow : false
          }, null, 8, ["prop", "label", "min-width", "show-overflow-tooltip"]);
        }), 128)), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "15%"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            size: "small",
            onClick: $event => $setup.handleManager(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("指定为当前上级 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "page-size": _ctx.pageSize,
        onSizeChange: $setup.sizeChange,
        onCurrentChange: $setup.currentChange
      }, null, 8, ["current-page", "total", "page-size", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model-value", "onClose"]);
}